import { Injectable } from '@angular/core';

import { Preferences } from '@capacitor/preferences';

import { BatteryOptimization } from '@capawesome-team/capacitor-android-battery-optimization';

import { DeviceService } from '@core/services/device/device.service';
import { TypeUtilService } from '@core/services/utils/type-util.service';

@Injectable({
  providedIn: 'root'
})
export class BatteryOptimizationService {
  private KEY = 'ASK_TURN_OFF_OPTIMIZATION';

  constructor() {}

  async disableOptimizationWhenEnabled() {
    const { value } = await Preferences.get({ key: this.KEY });
    const ask = value === null;
    const enabled = await this.isBatteryOptimizationEnabled();
    if (enabled && ask) {
      await this.requestIgnoreBatteryOptimization();
    }
    await Preferences.set({ key: this.KEY, value: '0' });
  }

  private async isBatteryOptimizationEnabled() {
    if (!DeviceService.isAndroid) {
      return false;
    }

    const { enabled } = await BatteryOptimization.isBatteryOptimizationEnabled();

    return enabled;
  }

  private async requestIgnoreBatteryOptimization() {
    if (!DeviceService.isAndroid) {
      return;
    }
    await BatteryOptimization.requestIgnoreBatteryOptimization();
  }
}
